/**
 * Movie Studio screen. A reel is story, picture, timeline, and sound.
 * Photo Studio and the design editor are not mounted here.
 */

import type { Project } from '@canvas/shared-types';
import ReelStudio from './ReelStudio';

interface MovieEditorViewProps {
  project: Project;
  onBack: () => void;
}

/** Open a movie. */
export default function MovieEditorView({ project, onBack }: MovieEditorViewProps): JSX.Element {
  return <ReelStudio project={project} onBack={onBack} />;
}
